import './processes.css';
import * as React from 'react';
import {Component} from "react";
import {ProcessSingle} from "../../widgets";
import {setActiveMenuItem, setLogoWhite, setNavbarTheme} from "../../util";



export class ProcessThree extends Component {

    componentDidMount() {
        setNavbarTheme('#040f2b');
        setActiveMenuItem('prosess', window.innerWidth < 1000);
        setLogoWhite(false);
    }

    render() {
        return (
            <div className={'process-three'}>
                <ProcessSingle header={'3. Ressurser'} text={'Lorem Ipsum'} image={'resources/blonomResources.jpg'}/>
            </div>
        );
    }
}